<template>
    <div>
        <div id="resumo">
            <div class="table-container" v-if="isResumoActive">
                <table class="table">
                    <thead>
                        <tr>
                            <td class="center">Status</td>
                            <td class="center">Propriedade</td>
                            <td class="center">Descrição</td>
                            <td class="center">Área</td>
                            <td class="center">Produção</td>
                            <td class="center">Informações</td>
                            <td class="center">Mapa</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="center-table" v-for="sensor in filteredItems" :key="sensor.id">
                            <td>
                                <b-tooltip label="Inativo" type="is-danger"
                                    v-if="sensor.isActive === 0 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-remove" size="is-large" type="is-danger"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Ativo" type="is-success"
                                    v-else-if="sensor.isActive === 2 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-check" size="is-large" type="is-success"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Em Andamento" type="is-warning"
                                    v-else-if="sensor.isActive === 1 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-off" size="is-large" type="is-warning"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Pendente" type="is-info" v-else>
                                    <b-icon icon="access-point-network-off" size="is-large" type="is-info"></b-icon>
                                </b-tooltip>
                            </td>
                            <td class="center">{{ sensor.property }}</td>
                            <td class="center">{{ sensor.lowDescription }}</td>
                            <td class="center">{{ sensor.area }} ha</td>
                            <td class="center">{{ sensor.typeProduction }}</td>
                            <td>
                                <b-tooltip v-if="sensor.idSensor === null" label="Sensor não atribuído">
                                    <b-button type="is-primary" tag="router-link"
                                        :to="sensor.idSensor ? { path: '/detalhes/' + sensor.idSensor } : '#'"
                                        :disabled="sensor.idSensor === null">
                                        Detalhes
                                    </b-button>
                                </b-tooltip>
                                <b-button v-else type="is-primary" tag="router-link"
                                    :to="'/detalhes/' + sensor.idSensor">
                                    Detalhes
                                </b-button>

                            </td>
                            <td>
                                <b-button icon-left="arrow-right" @click="updateMap(sensor.id)">
                                </b-button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
        <div id="area">
            <div class="table-container" v-if="isAreaActive">
                <table class="table">
                    <thead>
                        <tr>
                            <td class="center">Status</td>
                            <td class="center">Propriedade</td>
                            <td class="center">Hectares</td>
                            <td class="center">Metros</td>
                            <td class="center">Acres</td>
                            <td class="center">Informações</td>
                            <td class="center">Mapa</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="center-table" v-for="sensor in filteredItems" :key="sensor.id">
                            <td>
                                <b-tooltip label="Inativo" type="is-danger"
                                    v-if="sensor.isActive === 0 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-remove" size="is-large" type="is-danger"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Ativo" type="is-success"
                                    v-else-if="sensor.isActive === 2 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-check" size="is-large" type="is-success"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Em Andamento" type="is-warning"
                                    v-else-if="sensor.isActive === 1 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-off" size="is-large" type="is-warning"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Pendente" type="is-info" v-else>
                                    <b-icon icon="access-point-network-off" size="is-large" type="is-info"></b-icon>
                                </b-tooltip>
                            </td>
                            <td class="center">{{ sensor.property }}</td>
                            <td class="center">{{ sensor.area }} ha</td>
                            <td class="center">{{ sensor.area * 10000 }} m²</td>
                            <td class="center">{{ sensor.area * 2.471 }}ac</td>
                            <td>
                                <b-button type="is-primary" tag="router-link" :to="{ path: '/detalhes/' + sensor.id }">
                                    Detalhes
                                </b-button>

                            </td>
                            <td>
                                <b-button icon-left="arrow-right" @click="updateMap(sensor.id)">
                                </b-button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
        <div id="producao">
            <div class="table-container" v-if="isProducaoActive">
                <table class="table">
                    <thead>
                        <tr>
                            <td class="center">Status</td>
                            <td class="center">Propriedade</td>
                            <td class="center">Tipo</td>
                            <td class="center">Descrição</td>
                            <td class="center">Informações</td>
                            <td class="center">Mapa</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="center-table" v-for="sensor in filteredItems" :key="sensor.id">
                            <td>
                                <b-tooltip label="Inativo" type="is-danger"
                                    v-if="sensor.isActive === 0 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-remove" size="is-large" type="is-danger"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Ativo" type="is-success"
                                    v-else-if="sensor.isActive === 2 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-check" size="is-large" type="is-success"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Em Andamento" type="is-warning"
                                    v-else-if="sensor.isActive === 1 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-off" size="is-large" type="is-warning"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Pendente" type="is-info" v-else>
                                    <b-icon icon="access-point-network-off" size="is-large" type="is-info"></b-icon>
                                </b-tooltip>
                            </td>
                            <td class="center">{{ sensor.property }}</td>
                            <td class="center">{{ sensor.typeProduction }}</td>
                            <td class="center" v-if="sensor.typeProduction == 'Arroz'">Produção de arroz de tipo
                                indeterminado,
                                faça
                                correção de pH e a adubação recomendada para a cultura</td>
                            <td class="center" v-else-if="sensor.typeProduction == 'Milho em grão'">Produção de milho em
                                grão.
                                Plantio Agosto-Dezembro e Janeiro-Março; Colheita Março-Junho e Junho-Dezembro</td>
                            <td class="center" v-else-if="sensor.typeProduction == 'Soja'">Produção de soja de tipo
                                indeterminado.
                                Plantio Outubro-Novembro; Colheita Maio</td>
                            <td class="center" v-else-if="sensor.typeProduction == 'Cana-de-açúcar'">Produção de
                                Cana-de-açúcar.
                                Plantio Janeiro-Fevereiro; Colheita Abril-Agosto</td>
                            <td class="center" v-else-if="sensor.typeProduction == 'Café'">Produção de Café. Plantio
                                Janeiro-Março;
                                Colheita Abril-Setembro.</td>
                            <td class="center" v-else-if="sensor.typeProduction == 'Algodão'">Produção de Algodão
                                herbáceo.
                                Plantio
                                Novembro-Março; Colheita Maio-Agosto</td>
                            <td class="center" v-else-if="sensor.typeProduction == 'Mandioca'">Produção de Mandioca.
                                Plantio
                                Agosto-Setembro; Colheita Março-Julho</td>
                            <td class="center" v-else-if="sensor.typeProduction == 'Laranja'">Cultivare de Laranja de
                                tipo
                                indeterminado. Maturação Indeterminada</td>
                            <td class="center" v-else-if="sensor.typeProduction == 'Trigo'">Produção de Trigo de tipo
                                indeterminado.
                                Plantio Outubro-Novembro-Dezembro; Colheita Abril-Maio</td>
                            <td class="center" v-else-if="sensor.typeProduction == 'Banana'">Cultivo de Banana. Produção
                                o
                                ano
                                inteiro; Colheita um ano após</td>
                            <td class="center" v-else>Sensor não atribuido a nenhum tipo de produção. Utilizado para
                                fins
                                específicos.</td>
                            <td>
                                <b-button type="is-primary" tag="router-link" :to="{ path: '/detalhes/' + sensor.id }">
                                    Detalhes
                                </b-button>

                            </td>
                            <td>
                                <b-button icon-left="arrow-right" @click="updateMap(sensor.id)">
                                </b-button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
        <div id="localizacao">
            <div class="table-container" v-if="isLocalizacaoActive">
                <table class="table">
                    <thead>
                        <tr>
                            <td class="center">Status</td>
                            <td class="center">Propriedade</td>
                            <td class="center">Latitude</td>
                            <td class="center">Longitude</td>
                            <td class="center">Localidade</td>
                            <td class="center">Informações</td>
                            <td class="center">Mapa</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="center-table" v-for="sensor in filteredItems" :key="sensor.id">
                            <td>
                                <b-tooltip label="Inativo" type="is-danger"
                                    v-if="sensor.isActive === 0 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-remove" size="is-large" type="is-danger"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Ativo" type="is-success"
                                    v-else-if="sensor.isActive === 2 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-check" size="is-large" type="is-success"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Em Andamento" type="is-warning"
                                    v-else-if="sensor.isActive === 1 && sensor.idSensor !== null">
                                    <b-icon icon="access-point-off" size="is-large" type="is-warning"></b-icon>
                                </b-tooltip>
                                <b-tooltip label="Pendente" type="is-info" v-else>
                                    <b-icon icon="access-point-network-off" size="is-large" type="is-info"></b-icon>
                                </b-tooltip>
                            </td>
                            <td class="center">{{ sensor.property }}</td>
                            <td class="center">{{ sensor.latitude }}</td>
                            <td class="center">{{ sensor.longitude }}</td>
                            <td class="center">{{ sensor.city }}, {{ sensor.state }}</td>
                            <td>
                                <b-button type="is-primary" tag="router-link" :to="{ path: '/detalhes/' + sensor.id }">
                                    Detalhes
                                </b-button>

                            </td>
                            <td>
                                <b-button icon-left="arrow-right" @click="updateMap(sensor.id)">
                                </b-button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InfoSensor',
    props: {
        isResumoActive: Boolean,
        isAreaActive: Boolean,
        isProducaoActive: Boolean,
        isLocalizacaoActive: Boolean,
        filteredItems: Array,
    },
    methods: {
        updateMap(id) {
            this.$emit('updateMap', id);
        },
    },
};
</script>